<script src="../main.js"></script>
<template>
  <div class="header is-active-page">
    <img class="logo" src="../assets/homePage/logo.png"/>
    <el-menu :default-active="defaultActive" mode="horizontal" @select="handleSelect">
      <el-menu-item index="/">首页</el-menu-item>
      <el-menu-item index="/aboutJiuju">关于玖聚</el-menu-item>
      <el-menu-item index="/professionalField">专业领域</el-menu-item>
      <el-menu-item index="/jiujuTeam">玖聚团队</el-menu-item>
      <el-menu-item index="/contactUs">联系我们</el-menu-item>
    </el-menu>
  </div>
</template>

<script>
export default {
  name:'Nav',
  props:{
    isFirstPage:{
      type:Boolean,
      default:true
    }
  },
  data() {
    return {
      defaultActive: this.$route.path,    // 跳转到对应的路由s,
      lastScrollPosition: 0,
      isHovered: false,
      submenuPosition: 0,  // 用于存储 el-submenu 的位置
    };
  },
  computed: {
    isScrolled() {
      return this.lastScrollPosition !== 0;
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('mousemove', this.handleMouseMove);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('mousemove', this.handleMouseMove);
  },
  methods: {
    handleSelect(key) {
      // 如果目标路径和当前路径相同，则不进行导航
      if (this.$route.path !== key) {
        this.$nextTick(() => {
          this.$router.replace(key);
        });
      }
    },
    handleScroll() {
      this.lastScrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    },
    handleMouseMove(event) {
      this.isHovered = event.clientY < 180;
    }
  }
};
</script>

<style lang="scss">
.header {
  color: rgba(255, 255, 255, 0.8);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 80px;
  z-index: 1000;
  display: flex;
  align-items: center;
  transition: background-color 0.3s ease;
  .logo {
    margin-left: 10vw;
  }
  .el-menu {
    align-items: center;
    display: flex;
    position: absolute;
    right: 10vw;
    height: 80px;
    background: transparent;
    font-weight: 400;
    font-size: 18px;
    color: rgba(102,102,102,0.8);
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
  .el-menu-item, .el-menu--horizontal,
  .el-menu--horizontal > .el-menu-item.is-active,
  .el-menu--horizontal>.el-submenu.is-active .el-submenu__title,
  .el-menu--horizontal>.el-submenu .el-submenu__title {
    border-bottom: 0 !important;
  }
  .el-menu--horizontal > .el-menu-item.is-active {
    font-weight: 600;
    color: #FFFFFF;
  }
}

.is-active-page {
  background-color: #FFFFFF;
  .el-menu--horizontal > .el-menu-item.is-active,
  .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
    color: #AD867E;
  }
  .el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
  .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
    color: #AD867E;
  }
}
.el-submenu__popper {
  z-index: 1050 !important; /* 增加z-index */
}
</style>
